import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SwitchInputProps } from "@/types";
import { useVModel } from "@/hooks";
import { Typography } from "@/components/common/display";


/**
 * Displays a generic switch input.
 */
const __default__ = {
  name: "SwitchInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { type: Boolean },
    label: {},
    color: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;



const model = useVModel(props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_q_toggle = _resolveComponent("q-toggle")!

  return (_openBlock(), _createBlock(_component_q_toggle, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    color: props.color
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Typography), {
        value: props.label,
        color: props.color
      }, null, 8, ["value", "color"])
    ]),
    _: 1
  }, 8, ["modelValue", "color"]))
}
}

})